'use strict';

module.exports = {
    /**
     * 扫描二维码并返回结果<br />
     * 对应native接口：scanQRCode
     * @method hysdk.scanQRCode
     * @category Scan
     * @example ./scanQRCode.js[1-12]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | needResult | Number | 是否处理扫描结果 | X | 非常用参数，默认为0，扫描结果由微信处理，1则直接返回扫描结果 |
     * | scanType | Array | 二维码类型 | X | 非常用参数，可以指定扫二维码还是一维码，默认二者都有 |
     * | success | Function | success 回调 | X | 常用参数 |
     * | fail | Function | fail 回调 | X | 常用参数 |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    scanQRCode: {
        hy: {
            key: 'scanQRCode'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    result: ret.resultStr
                };
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/scan.js
// module id = 15
// module chunks = 0 2 4